export default "__VITE_ASSET__2feceb57__"